import { IDAL } from "../services/IDAL";
import DeviceUtils, { Platform } from "./DeviceUtils";
import BrowserAdapter from "./BrowserAdapter";
import CordovaAdapter from "./CordovaAdapter";
import ElectronAdapter from "./ElectronAdapter";

class ServiceUtilsClass {
    private activeService: Promise<IDAL>;
    public getActiveService(): Promise<IDAL> {
        if(this.activeService) { return this.activeService; }

        return this.activeService = new Promise<IDAL>((resolve, reject) => {
            DeviceUtils.loadDeviceInfo().then(deviceInfo => {
                switch (deviceInfo.platform) {
                    case Platform.Browser: 
                        resolve(new BrowserAdapter());
                        break;
                    case Platform.Cordova: 
                        resolve(new CordovaAdapter());
                        break;
                    case Platform.Electron: 
                        resolve(new ElectronAdapter());
                        break;
                    default: 
                        resolve(new BrowserAdapter());
                }
            });
        });
    }
}

export const ServiceUtils = new ServiceUtilsClass();